<template>
    <div id="set" class="w1440">
        <zxHead></zxHead>
        <div class="set">
            <zxTabbar :tabbarIndex='1'></zxTabbar>
            <div class="content">
                <div class="tableBox">
                    <ul>
                        <li>
                            <p class="title">消耗排序</p>
                        </li>
                        <li>
                            <div class="calendarbox">
                                <div @click="calendarstatus=!calendarstatus" class="calendartimebox">
                                    <p>
                                        <span>{{time.startTime.slice(5)}}</span> - <span>{{time.endTime.slice(5)}}</span>
                                    </p>
                                    <img src="@/assets/akar-icons_chevron-down.png" alt="">
                                </div>

                                <div v-if="calendarstatus" class="zx-calendar" ref="zxcalendar" v-clickoutside="handleClickOutside">
                                   <!-- <p class="title">消耗排序</p> -->
                                    <calendar @selectTime="selectTime" :start_time="time.startTime" :end_time="time.endTime"></calendar>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <el-table
                        :default-sort="defaultSortProp"
                        sortable="custom"
                        @sort-change="statisticsSortChange"
                        :data="tableData" style="width: 800px">
                        <el-table-column prop="companyName" label="账户" width="290">
                        </el-table-column>
                        <el-table-column prop="clickTimes" label="点击数" width="140" sortable="true">
                        </el-table-column>
                        <el-table-column prop="conversionTimes" label="转化数" width="140" sortable="true"></el-table-column>
                        <el-table-column prop="totalConsumption" label="消耗金额" width="120" sortable="true"></el-table-column>
                        <el-table-column prop="balance" label="余额" width="80" sortable="true"></el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        :current-page="statisticsPageParams.pageNo"
                        :page-sizes="[5, 10, 20, 30, 40]"
                        :page-size="statisticsPageParams.pageSize"
                        layout="sizes, prev, pager, next, jumper"
                        @current-change="handleStatisticsCurrentPageChange"
                        @size-change="handleStatisticsPageSizeChange"
                        :total="statisticsPageParams.total">
                    </el-pagination>
                </div>

                <div class="button" @click="addDialogVisible=true">
                    <img src="@/assets/Path.png" alt="">
                    <span>新建用户</span>
                </div>
                <!-- 账户列表 -->
                <div class="account">
                    <p class="title">账户信息</p>
                    <el-table ref="multipleTable" :data="accountData" tooltip-effect="dark" style="width: 100%">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="userId" label="用户编号" width="80"></el-table-column>
                        <el-table-column prop="username" label="用户名称"></el-table-column>
                        <el-table-column prop="nickName" label="公司名称"></el-table-column>
                        <el-table-column prop="balance" label="余额"></el-table-column>
                        <el-table-column prop="deduction" label="扣费标准"></el-table-column>
                        <el-table-column label="状态" width="80">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.status"
                                           active-value='0' inactive-value='1'
                                            @change="switchUserStatus(scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间">
                            <template slot-scope="scope">
                                <p style="font-size:12px">{{scope.row.createTime}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-edit" @click="clickEditUser(scope.row)">修改</el-button>
                                <el-button type="text" icon="el-icon-edit" @click="clickChargeUser(scope.row)">充值</el-button>
                                <el-button type="text" icon="el-icon-delete" @click="delUser(scope.row)">删除</el-button>
                                <el-popover
                                placement="bottom"
                                width="150"
                                trigger="click">
                                    <el-button type="text" icon="el-icon-edit" style="color:#000" @click="clickResetUserPwd(scope.row)">重置密码</el-button><br/>
                                    <el-button type="text" icon="el-icon-delete" style="color:#000" @click="clickShowRole(scope.row)">分配角色</el-button>
                                    <el-button slot="reference" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                                </el-popover>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        :current-page="userPageParams.pageNo"
                        :page-sizes="[5, 10, 20, 30, 40]"
                        :page-size="userPageParams.pageSize"
                        layout="sizes, prev, pager, next, jumper"
                        @current-change="handleUserCurrentPageChange"
                        @size-change="handleUserPageSizeChange"
                        :total="userPageParams.total">
                    </el-pagination>
                </div>
            </div>
            <!-- 新增用户弹框 -->
            <div class="popup" v-show="addDialogVisible">
                <div class="popupBox">
                    <div class="close">
                        <i class="el-icon-close" @click="addDialogVisible=false"></i>
                    </div>
                    <p class="title">添加用户</p>
                    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
                        <el-form-item label="公司名称" prop="company">
                            <el-input v-model="form.company"></el-input>
                        </el-form-item>
                        <el-form-item label="用户名称" prop="account">
                            <el-input v-model="form.account"></el-input>
                        </el-form-item>
                        <el-form-item label="用户密码" prop="password">
                            <el-input v-model="form.password" show-password></el-input>
                        </el-form-item>
<!--                        <el-form-item label="扣费标准" prop="charging">-->
<!--                            <el-input v-model="form.charging"></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item label="投放链接" prop="link">
                            <el-input v-model="form.link"></el-input>
                        </el-form-item>
                        <el-form-item label="二维码链接" prop="qrcode">
                            <el-input v-model="form.qrcode"></el-input>
                        </el-form-item>
<!--                        <el-form-item label="余额与消耗金额展现" class="last">-->
<!--                            <el-checkbox v-model="form.display"></el-checkbox>-->
<!--                        </el-form-item>-->
                    </el-form>
                </div>

                <div class="submitbutton" @click="addUser()">完成新建</div>
            </div>
          <!-- 修改用户弹框 -->
          <div class="popup" v-show="editDialogVisible">
            <div class="popupBox">
              <div class="close">
                <i class="el-icon-close" @click="editDialogVisible=false"></i>
              </div>
              <p class="title"> 修改用户</p>
              <el-form ref="form" :model="editForm" label-width="80px">
                <el-form-item label="公司名称" prop="company">
                  <el-input v-model="editForm.company"></el-input>
                </el-form-item>
                <el-form-item label="用户名称" prop="account">
                  <el-input disabled v-model="editForm.account"></el-input>
                </el-form-item>
                <el-form-item label="扣费标准" prop="charging">
                  <el-input v-model="editForm.charging"></el-input>
                </el-form-item>
              </el-form>
            </div>

            <div class="submitbutton" @click="editUser()">确定</div>
          </div>
          <!-- 充值弹框 -->
          <el-dialog title="充值" :visible.sync="chargeDialogVisible" width="600px" append-to-body>
            <el-form ref="editForm" :model="editForm" label-width="80px" :rules="editRules">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="充值金额" prop="addBalance">
                    <el-input v-model="editForm.addBalance" placeholder="请输入充值金额" maxlength="30" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="chargeUser">确 定</el-button>
              <el-button @click="chargeDialogVisible=false">取 消</el-button>
            </div>
          </el-dialog>

          <!-- 重置密码弹框 -->
          <el-dialog title="重置密码" :visible.sync="resetPwdDialogVisible" width="600px" append-to-body>
            <el-form ref="editForm" :model="editForm" label-width="80px" :rules="editRules">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="新密码" prop="newPwd">
                    <el-input v-model="editForm.newPwd" placeholder="请输入新密码" maxlength="30" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="resetUserPwd()">确 定</el-button>
              <el-button @click="resetPwdDialogVisible=false">取 消</el-button>
            </div>
          </el-dialog>
        </div>
        <role :visible="roleDialogVisible" :user="editForm" @closeRoles="closeRoles"></role>
    </div>
</template>

<script>
import {Message} from "element-ui";

var _this
import zxHead from '@/components/head'
import zxTabbar from '@/components/tabbar'
import calendar from '@/components/calendar'
import role from '@/components/role/role.vue'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import {getDay} from "@/util/fun";
import {statisticsGroupByUser} from '@/api/index/statistics'
import {page, add, edit, del, charge, resetPwd, enable, disable} from '@/api/user'
export default {
    directives: { Clickoutside },
    components:{
        zxHead,
        zxTabbar,
        calendar,
        role
    },
    data(){
        return {
            calendarstatus:false,
            addDialogVisible:false,
            editDialogVisible: false,
            chargeDialogVisible: false,
            resetPwdDialogVisible: false,
            roleDialogVisible: false,
            time:{
                startTime: getDay(0),
                endTime: getDay(0),
            },
            defaultSortProp: {
              prop: "clickTimes",
              order: "descending"
            },
            // 选择的排序
            chooseSortProp: null,
            form:{
                company:"",//公司名称
                account:'',//用户名称
                password:"",//用户密码
                charging:"",//扣费标准
                link:"",//投放链接
                qrcode:"",//二维码管
                display:false,//余额与消耗金额展现
            },
            rules:{
                company: { required: true, message: '请输入公司名称', trigger: 'blur' },
                account: { required: true, message: '请输入用户名称', trigger: 'blur' },
                password: { required: true, message: '请输入用户密码', trigger: 'blur' },
                charging: {required: true, message: '请输入扣费金额', trigger: 'blur'},
                link: {required: true, message: '请输入链接地址', trigger: 'blur'},
                qrcode: {required: true, message: '请输入二维码地址', trigger: 'blur'}
            },
            editForm: {
              company: "",
              charging: "",
              addBalance: "",
              newPwd: ""
            },
          editRules:{
            addBalance: {required: true, message: '请输入充值金额', trigger: 'blur'},
            newPwd: {required: true, message: '请输入新密码', trigger: 'blur'}
          },
            tableData:[
                // {
                //     companyName:"建登",//账户
                //     clickTimes:"48928",//点击数
                //     conversionTimes:"4958",//转化数
                //     totalConsumption:"1467.84",//消耗金额
                //     balance:"1029.38"//余额
                // }
            ],
            accountData:[
                // {
                //     userId:1,//用户编号
                //     username:"dengjian",//用户名称
                //     nickName:"建登",//公司名称
                //     balance:"1029.03",//余额
                //     deduction:"0.03",//扣费标准
                //     status:0,//状态
                //     createTime:"2023-07-07 10:22:09"//创建时间
                // },
            ],

          /**
           * 消耗列表，分页查询参数
           */
          statisticsPageParams: {
              pageNo: 1,
              pageSize: 5,
              total: 0
            },

            userPageParams: {
              pageNo: 1,
              pageSize: 5,
              total: 0
            }
        }
    },
    mounted() {
        _this =this;
        _this.chooseSortProp = _this.defaultSortProp;
        _this.showStatisticsData();
        _this.userPage();
    },
    methods: {
        selectTime(data){
            _this.time.startTime = data[0]
            _this.time.endTime = data[1]
            _this.$nextTick(function(){
                _this.calendarstatus = false
            })
          _this.statisticsPageParams.pageNo = 1;
          _this.chooseSortProp = null;
          _this.showStatisticsData();
        },
        handleClickOutside(){
            _this.calendarstatus = false
        },
      /**
       * 统计按字段排序
       * @param prop
       */
      statisticsSortChange(prop) {
        delete prop.column;
        _this.statisticsPageParams.pageNo = 1;
        _this.chooseSortProp = prop;
        this.showStatisticsData();
      },

      /**
       * 展示统计数据
       */
      showStatisticsData() {
        let data = {
          pageNo: _this.statisticsPageParams.pageNo,
          pageSize: _this.statisticsPageParams.pageSize,
          search: _this.timeConvert()
        };
        if (_this.chooseSortProp && _this.chooseSortProp.order) {
          data.search.orderBy = _this.chooseSortProp;
        }
         statisticsGroupByUser(data).then(res => {
          if (res.ok) {
            _this.statisticsPageParams.total = res.data.total;
            _this.tableData = res.data.data;
          } else {
            Message({type: 'error', message: res.msg});
          }
        })
      },
      timeConvert() {
        return {
          startTimeStamp: new Date(_this.time.startTime + " 00:00:00").getTime() / 1000,
          endTimeStamp: new Date(_this.time.endTime + " 23:59:59").getTime() / 1000
        };
      },
      /**
       * 用户列表展示
       */
      userPage() {
        let data = {
          pageNo: _this.userPageParams.pageNo,
          pageSize: _this.userPageParams.pageSize,
          search: {

          }
        };
        page(data).then(res => {
          if (res.ok) {
            _this.userPageParams.total = res.data.total;
            _this.accountData = res.data.data;
          } else {
            Message({type: 'error', message: res.msg});
          }
        })
      },

      /**
       * 统计列表分页查询条件，页码变更时触发
       * @param val
       */
      handleStatisticsCurrentPageChange(val) {
        _this.statisticsPageParams.pageNo = val;
        _this.showStatisticsData();
      },
      /**
       * 统计列表分页查询条件，每页最大数变更时触发
       * @param val
       */
      handleStatisticsPageSizeChange(val) {
        _this.statisticsPageParams.pageSize = val;
        _this.showStatisticsData();
      },
      /**
       * 用户列表分页查询条件，页码变更时触发
       * @param val
       */
      handleUserCurrentPageChange(val) {
        _this.userPageParams.pageNo = val;
        _this.userPage();
      },
      /**
       * 用户列表分页查询条件，每页最大数变更时触发
       * @param val
       */
      handleUserPageSizeChange(val) {
        _this.userPageParams.pageSize = val;
        _this.userPage();
      },
      /**
       * 新增用户
       */
      addUser() {
        let data = {
          username: _this.form.account,
          nickName: _this.form.company,
          password: _this.form.password,
          deduction: _this.form.charging,
          landingPageUri: _this.form.link,
          qrCodeUri: _this.form.qrcode
        }
        add(data).then(res => {
          if (res.ok) {
            Message({type: 'success', message: '新增成功'});
            _this.addDialogVisible = false;
            _this.userPage();
          } else {
            Message({type: 'error', message: res.msg});
          }
        }).catch(e => {
          Message({type: 'error', message: e});
        })
      },

      clickEditUser(item) {
        _this.editForm = {
          userId: item.userId,
          company: item.nickName,
          account: item.userName,
          charging: item.deduction
        };
        _this.editDialogVisible = true;
      },
      editUser() {
        let data = {
          userId: _this.editForm.userId,
          nickName: _this.editForm.company,
          deduction: _this.editForm.charging
        }
        edit(data).then(res => {
          if (res.ok) {
            _this.editForm = {};
            Message({type: 'success', message: "修改成功"});
            _this.editDialogVisible = false;
            _this.userPage();
          } else {
            Message({type: 'error', message: res.msg});
          }
        }).catch(e => {
          Message({type: 'error', message: e});
        })
      },
      delUser(item) {
        del(item.userId).then(res => {
          if (res.ok) {
            Message({type: 'success', message: '删除成功'});
            _this.userPage();
          } else {
            Message({type: 'error', message: res.msg});
          }
        }).catch(e => {
          Message({type: 'error', message: e});
        })
      },
      clickChargeUser(item) {
        _this.editForm.userId = item.userId;
        _this.chargeDialogVisible = true;
      },
      switchUserStatus(item) {
        // 使用change事件，会先更改v-model绑定的值，在调用change事件
        if (item.status == 0) {
          enable(item.userId).then(res => {
            if (res.ok) {
              Message({type: 'success', message: '启用用户成功'});
            } else {
              Message({type: 'error', message: res.msg});
            }
          });
        } else {
          disable(item.userId).then(res => {
            if (res.ok) {
              Message({type: 'success', message: '禁用用户成功'});
            } else {
              Message({type: 'error', message: res.msg});
            }
          });
        }
      },
      /**
       * 给用户充值
       */
      chargeUser() {
        let data = {
          userId: _this.editForm.userId,
          addBalance: _this.editForm.addBalance
        }
        charge(data).then(res => {
          if (res.ok) {
            Message({type: 'success', message: "充值成功"});
            _this.chargeDialogVisible = false;
            _this.userPage();
          } else {
            Message({type: 'error', message: res.msg});
          }
        }).catch(e => {
          Message({type: 'error', message: e});
        })
      },
      clickResetUserPwd(item) {
        _this.editForm.userId = item.userId;
        _this.resetPwdDialogVisible = true;
      },
      resetUserPwd() {
        let data = {
          userId: _this.editForm.userId,
          newPwd: _this.editForm.newPwd
        }
        resetPwd(data).then(res => {
          if (res.ok) {
            Message({type: 'success', message: "重置密码成功"});
            _this.resetPwdDialogVisible = false;
            _this.userPage();
          } else {
            Message({type: 'error', message: res.msg});
          }
        }).catch(e => {
          Message({type: 'error', message: e});
        })
      },
      clickShowRole(item) {
        _this.editForm = item;
        _this.roleDialogVisible = true;
      },
      closeRoles() {
        _this.editForm = {};
        _this.roleDialogVisible = false;
      }
    }
}
</script>

<style lang="less">
    #set{
        .set{
            display: flex;
            .tableBox{
                border-radius: 20.37px;
                background: rgba(255, 255, 255, 1);
                border: 2px solid rgba(239, 238, 235, 1);
                // overflow: hidden;
                padding: 30px 28px;
                margin-bottom: 22px;
                width: 848px;
                .el-table__row{
                    .el-table__cell{
                        border-bottom: none!important;
                    }
                }
                .el-table::before{
                    background-color: transparent;
                }
                .el-table__header-wrapper{
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(96, 96, 96, 1);
                }
                .cell{
                    padding: 0;
                }
                ul{
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 36px;
                    .title{
                        font-size: 18px;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 1);
                    }
                    .calendarbox{
                        position: relative;
                        .calendartimebox{
                            border-radius: 12px;
                            background: rgba(246, 246, 246, 1);
                            box-shadow: 2px 2px 7px  rgba(0, 0, 0, 0.25);
                            padding: 10px 10px 10px 10px;
                            display: flex;
                            align-items: center;
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 1);
                            cursor: pointer;
                            img{
                                width: 16px;
                                margin-top: -2px;
                            }
                        }
                        .zx-calendar{
                            position: absolute;
                            top: 110%;
                            left: 50%;
                            transform: translateX(-50%);
                            z-index: 100;
                        }
                    }
                }
                .el-pagination{
                  text-align: right;
                  margin-top: 30px;
                  margin-bottom: 0;
                  display: inline-flex;
                  .active{
                    background-color: #1F5288;
                  }
                }
            }

            .button{
                width: 142px;
                opacity: 1;
                border-radius: 10px;
                background: rgba(229, 229, 229, 1);
                padding: 12px;
                display: flex;
                align-items: center;
                font-size: 13px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
                margin-bottom: 30px;
                cursor: pointer;
                img{
                    width: 12px;
                    margin-right: 30px;
                }
            }

            .account{
                width: 1177px;
                border-radius: 20.37px;
                background: rgba(255, 255, 255, 1);
                border: 2px solid rgba(239, 238, 235, 1);
                overflow: hidden;
                padding: 30px 30px 8px 30px;
                .title{
                    font-size: 18px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 1);
                    margin-bottom: 16px;
                }
                .el-pagination{
                    text-align: right;
                    margin-top: 30px;
                    .active{
                        background-color: #1F5288;
                    }
                }
            }
            .popup{
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                width:400px;
                border-radius: 20px;
                box-shadow: 0px 20px 60px  rgba(0, 0, 0, 0.05);
                background-color: #fff;
                z-index: 10;
                overflow: hidden;
                .close{
                    text-align: right;
                    // font-size:14px;
                    color:rgba(184, 193, 204, 1);
                    i{
                        cursor: pointer;
                    }
                }
                .title{
                    font-size: 26px;
                    font-weight: 700;
                    color: rgba(50, 62, 77, 1);
                    margin-bottom: 10px;
                }
                .popupBox{
                    padding: 32px 32px 0;
                }
                .el-form{
                    .last{
                        .el-form-item__label{
                            width: 140px!important;
                        }
                    }
                }
                .submitbutton{
                    margin-top: 100px;
                    width: 100%;
                    background: linear-gradient(180deg, rgba(0, 119, 255, 1) 0%, rgba(0, 175, 255, 1) 100%);
                    text-align: center;
                    padding: 25px 0;
                    font-size: 14px;
                    font-weight: 700;
                    color: rgba(252, 254, 255, 1);
                    cursor: pointer;
                }
            }
        }
    }
</style>
